<template>
  <div>
    <label class="item-name"><i class="required" v-show="component.properties.required">*</i>{{initComponent.name}}</label>
    <div class="component-content">
      <el-input :class="{onlyread:component.properties.readonly}" :placeholder="initComponent.properties.placeholder" disabled/>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'
export default {
  name: 'rc-input',
  props: ['initComponent'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/components/input/rc-input.vue